/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { TeamLegalEntityAddress } from './';
import {
    TeamLegalEntityAddressFromJSON,
    TeamLegalEntityAddressFromJSONTyped,
    TeamLegalEntityAddressToJSON,
} from './';

/**
 * 
 * @export
 * @interface TeamLegalEntityBillingProfile
 */
export interface TeamLegalEntityBillingProfile {
    /**
     * 
     * @type {string}
     * @memberof TeamLegalEntityBillingProfile
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TeamLegalEntityBillingProfile
     */
    label: string;
    /**
     * 
     * @type {TeamLegalEntityAddress}
     * @memberof TeamLegalEntityBillingProfile
     */
    address: TeamLegalEntityAddress;
    /**
     * 
     * @type {string}
     * @memberof TeamLegalEntityBillingProfile
     */
    registrationNumber?: string;
}

/**
 * Check if a given object implements the TeamLegalEntityBillingProfile interface.
 */
export function instanceOfTeamLegalEntityBillingProfile(value: object): value is TeamLegalEntityBillingProfile {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    return true;
}

export function TeamLegalEntityBillingProfileFromJSON(json: any): TeamLegalEntityBillingProfile {
    return TeamLegalEntityBillingProfileFromJSONTyped(json, false);
}

export function TeamLegalEntityBillingProfileFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamLegalEntityBillingProfile {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'label': json['label'],
        'address': TeamLegalEntityAddressFromJSON(json['address']),
        'registrationNumber': json['registrationNumber'] == null ? undefined : json['registrationNumber'],
    };
}

export function TeamLegalEntityBillingProfileToJSON(value?: TeamLegalEntityBillingProfile | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'label': value['label'],
        'address': TeamLegalEntityAddressToJSON(value['address']),
        'registrationNumber': value['registrationNumber'],
    };
}

